<!-- Accordions Copyright 2022 Rebecca L Beaudet -->
<script lang="ts">
  import type { listItem } from '../../language/interface';

  export let sections: listItem[] = [];
  export let heading: string = '';
  export let size: number = 3;
</script>

{#if sections.length}
  <div class={`col-md-${size}`}>
    {#if heading}
      <h4>{heading}</h4>
    {/if}
    <div class={`accordion`} id="pageAccordion">
      {#each sections as accordion, i}
        <div class="accordion-item">
          <h4 class="accordion-header" id={`heading-${i}`}>
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapse-${i}`}
              aria-expanded="false"
              aria-controls={`collapse-${i}`}
            >
              {accordion.title}
            </button>
          </h4>
          <div
            id={`collapse-${i}`}
            class="accordion-collapse collapse"
            aria-labelledby={`heading-${i}`}
            data-bs-parent="#pageAccordion"
          >
            <div class="accordion-body">
              {#if accordion?.content}
                <p>{accordion.content}</p>
              {/if}
              {#if accordion?.list}
                <ul>
                  {#each accordion.list as item}
                    <li>{item}</li>
                  {/each}
                </ul>
              {/if}
            </div>
          </div>
        </div>
      {/each}
    </div>
  </div>
{/if}
